const SignalRMessageOptions = {
	WentToQuote: "WentToQuote",
	WentToAdmin: "WentToAdmin"
};

export default SignalRMessageOptions;
